import { FindSimilarAccountsBtn } from "../ui/buttons";
import { GoToActionBlock } from "../products";
import { useGetCampaignSummaryQuery } from "../../api";
import { AnalysisStatus } from "../../types/companyTypes";

type Props = {
  campaign_id: string;
  isFirstSearch: boolean;
};

export const RecommendedActionBlock = ({
  campaign_id,
  isFirstSearch,
}: Props) => {
  const { data: summary } = useGetCampaignSummaryQuery({
    campaign_id,
  });

  const isLoading =
    summary?.recommended_accounts_status === AnalysisStatus.in_progress;

  const isCompleted =
    summary?.recommended_accounts_status === AnalysisStatus.completed;

  if (isCompleted && !isFirstSearch) return null;

  if (isFirstSearch) {
    return (
      <GoToActionBlock
        bgColor={"#F7F7F7"}
        border={"none"}
        title="No similar accounts discovered yet"
        texts={[
          "We haven’t found any recommended accounts based on your current targets.",
          "Explore similar accounts to support account expansion.",
        ]}
        btn={<FindSimilarAccountsBtn isLoading={isLoading} />}
      />
    );
  }

  return (
    <GoToActionBlock
      bgColor={"#F7F7F7"}
      border={"none"}
      title="Targeting has been updated"
      texts={[
        "You’ve made changes to targeting settings. Run a new search to discover recommended accounts",
        "that match the updated criteria.",
      ]}
      btn={<FindSimilarAccountsBtn isLoading={isLoading} />}
    />
  );
};
